<script>
import {defineComponent} from 'vue'
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue"
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue"
import InfoCards from "@js/components/InfoCards/Components/InfoCards.vue"
import PartnershipLayout from "@js/Shared/PartnershipLayout.vue"
import {useCallbackStore} from "@js/store/CallbackStore.js"
import FaqComponent from "@js/components/Faq/FaqComponent.vue"

import shield_svg from '@img/guarantee/shield.svg'
import star_svg from '@img/guarantee/star.svg'
import clock_svg from '@img/guarantee/clock.svg'
import money_svg from '@img/guarantee/money.svg'
import delivery_svg from '@img/guarantee/delivery.svg'
import certificate_svg from '@img/guarantee/certificate.svg'

export default defineComponent({
    layout: PartnershipLayout,
    name: "B2BForWorkshopsPage",
    components: {InfoCards, Breadcrumbs, MobileTopBar, FaqComponent},
    data() {
        return {
            items_group_1: [
                {
                    logo: shield_svg,
                    title: 'ГОСТ/ТУ и подтверждение марок стали',
                    description: 'Лист/рулон, балки и двутавр, швеллер, уголок, трубы, круг/квадрат — марочность и прокатку подтверждаем документально.',
                },
                {
                    logo: certificate_svg,
                    title: 'Сертификаты и прослеживаемость',
                    description: 'Передаём МК/сертификаты завода, фиксируем партии/плавки в закрывающих документах для прозрачного учёта.',
                },
                {
                    logo: clock_svg,
                    title: 'Отгрузка день-в-день со склада',
                    description: 'При наличии — оперативно готовим к выдаче и отправляем. Планируем поставки под сменный график цеха.',
                },
            ],
            items_group_2: [
                {
                    logo: money_svg,
                    title: 'НДС, ЭДО и возможная отсрочка',
                    description: 'Полный комплект первичных документов с НДС, электронный документооборот. Отсрочка — по договору и кредитной оценке.',
                },
                {
                    logo: delivery_svg,
                    title: 'Доставка «до ворот цеха»',
                    description: 'Москва и МО: согласуем тайм-слоты/пропуска, аккуратная разгрузка. Упаковка, прокладки, стяжка — сохранность грузов.',
                },
                {
                    logo: star_svg,
                    title: 'Спеццены и фиксация стоимости',
                    description: 'Индивидуальные условия для постоянных клиентов и регулярных закупок. Фиксация цены на согласованный срок.',
                },
            ],

            // SEO-FAQ (ровно 5)
            faqItems: [
                {
                    question: 'Для каких задач поставляете металл производственным цехам?',
                    answer: `<p>Для <strong>машиностроения</strong>, <strong>станкостроения</strong>, изготовления <strong>металлоконструкций</strong>, ремонтных и заготовительных участков. Поставляем <strong>лист/рулон</strong>, <strong>балки/двутавр</strong>, <strong>швеллер/уголок</strong>, <strong>профильные и круглые трубы</strong>, <strong>круг/квадрат</strong> по вашему ТЗ и ведомости.</p>`
                },
                {
                    question: 'Выполняете резку в размер и какие допуски по резу?',
                    answer: `<p>Да. Резка <strong>ленточной пилой/газом/плазмой</strong> по картам/чертежам. Согласуем требуемые допуски, обеспечиваем <strong>повторяемость партий</strong> и прикладываем упаковочные листы.</p>`
                },
                {
                    question: 'Какой минимальный объём отгрузки и возможны смешанные позиции?',
                    answer: `<p>Отгружаем партиями от <strong>1 тонны</strong>. Смешанные спецификации (лист + профиль + труба и т. п.) — без проблем, <strong>комплектуем под заявку</strong> и маркируем места для ускорения приёмки.</p>`
                },
                {
                    question: 'Какие условия по документам и срокам поставки?',
                    answer: `<p>Выставляем счета/накладные с <strong>НДС</strong>, поддерживаем <strong>ЭДО</strong>. При наличии на складе — <strong>отгрузка и доставка день-в-день</strong> по Москве и МО или по согласованному графику.</p>`
                },
                {
                    question: 'Делаете упаковку и маркировку для цехового учёта?',
                    answer: `<p>Да. Упаковываем с прокладками и стяжкой, <strong>маркируем места</strong>, прикладываем упаковочные листы — удобно для складского учёта и подачи в производство.</p>`
                },
            ],
        }
    },
    methods: {
        openForm() {
            this.callbackStore.showBaseCallbackPopup({
                title: 'Запросить КП для производственного цеха',
                bitrix_title: 'Заявка на партнёрство (производственные цеха • металлопрокат)',
            })
        }
    },
    setup() {
        const callbackStore = useCallbackStore()
        return {callbackStore}
    }
})
</script>

<template>
    <div>
        <div class="bg-black pt-5 md:pt-10 pb-[150px] text-white">
            <div class="container">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-10">
                    <div class="flex items-center justify-center">
                        <div>
                            <Breadcrumbs class="text-white" color="#ffcf33"/>
                            <h1 class="text-2xl md:text-4xl font-bold mb-5 mt-5">
                                B2B-решения для производственных цехов
                            </h1>
                            <p class="md:text-xl mb-5 md:max-w-[80%]">
                                Металлопрокат для заготовительных и механообрабатывающих участков: лист/рулон, балки и двутавр, швеллер, уголок, трубы, круг/квадрат. Отгрузка день-в-день и доставка «до ворот цеха».
                            </p>
                            <button
                                @click.prevent="openForm"
                                class="flex max-md:w-full justify-center items-center text-black md:hover:text-baseYellow border-2 border-baseYellow bg-baseYellow md:hover:bg-transparent font-bold rounded-lg text-sm px-14 py-2.5 focus:outline-none transition cursor-pointer uppercase"
                            >
                                Запросить КП
                            </button>
                        </div>
                    </div>
                    <div class="flex items-center justify-center max-md:hidden">
                        <img
                            src="@img/b2b/workshops/top-bg.webp"
                            class="max-h-[500px] rounded-full aspect-square object-cover"
                            alt="Металлопрокат для производственных цехов"
                            title="Поставки металлопроката для производственных участков"
                        />
                    </div>
                </div>
            </div>
        </div>
        <section class="bg-white rounded-t-[25px] md:rounded-t-[50px] -mt-[100px] md:mb-20">
            <div class="container pt-10 md:pt-20">
                <div class="grid grid-cols-1 gap-5">
                    <div class="bg-grayBg p-5 md:p-7 rounded-lg md:rounded-2xl">
                        <h3 class="text-xl md:text-2xl font-bold mb-3">
                            Металлопрокат для производственных цехов — Москва и МО
                        </h3>
                        <p class="mb-3">
                            Снабжаем производство <strong>под ключ</strong>: поставляем <strong>лист/рулон</strong>, <strong>балки/двутавр</strong>, <strong>швеллер/уголок</strong>, <strong>профильные и круглые трубы</strong>, <strong>круг/квадрат</strong>. Под ваше ТЗ обеспечиваем <strong>резку в размер</strong>, комплектовку и <strong>доставку</strong> с учётом окон разгрузки.
                        </p>
                        <p class="mb-3">
                            Поставки по <strong>ГОСТ/ТУ</strong> с сертификатами и полной прослеживаемостью. Резка <strong>ленточной пилой/газом/плазмой</strong> по картам/чертежам с контролем допусков и повторяемостью. При складской доступности — <strong>отгрузка в день заказа</strong>. Документы с <strong>НДС</strong>, поддерживаем <strong>ЭДО</strong>.
                        </p>
                        <ul class="list-disc list-outside space-y-2 ps-5 font-medium">
                            <li>комплектовка по заявкам/ведомостям, маркировка мест и упаковочные листы;</li>
                            <li>доставка по Москве и МО, согласование тайм-слотов и пропусков;</li>
                            <li>спецусловия для постоянных клиентов, <strong>фиксация цены</strong> на согласованный срок.</li>
                        </ul>
                    </div>
                    <div>
                        <div class="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5 h-full">
                            <div class="flex items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-center text-sm md:text-base lg:text-lg">
                                <p>Резка: ленточная пила/газ/плазма</p>
                            </div>
                            <div class="flex items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-center text-sm md:text-base lg:text-lg">
                                <p>Комплектовка по заявкам и картам</p>
                            </div>
                            <div class="flex items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-center text-sm md:text-base lg:text-lg">
                                <p>Партии от 1 т, смешанные позиции</p>
                            </div>
                            <div class="flex items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-center text-sm md:text-base lg:text-lg">
                                <p>Доставка «до ворот цеха»</p>
                            </div>
                            <div class="flex items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-center text-sm md:text-base lg:text-lg">
                                <p>Документы с НДС, ЭДО</p>
                            </div>
                            <div class="flex items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-center text-sm md:text-base lg:text-lg">
                                <p>Маркировка мест и упаковка</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <InfoCards :items_group_1="items_group_1" :items_group_2="items_group_2" class="mb-5 md:mb-20"/>
        <div class="container">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5 md:mb-20">
                <div class="bg-grayBg p-5 md:p-10 rounded-lg md:rounded-2xl">
                    <h2 class="text-2xl md:text-3xl font-bold mb-5">
                        Убираем рутину снабжения в цеху
                    </h2>
                    <p class="mb-3">
                        Берём на себя подбор по ГОСТ/ТУ, резку в размер, упаковку/маркировку и логистику — чтобы производство работало без простоев и срывов сроков.
                    </p>
                    <p class="mb-3">
                        Учитываем сменность, окна на разгрузку, требования к таре и складированию. Отслеживаем статусы отгрузок и уведомляем ответственных.
                    </p>
                    <p class="mb-3">Закрываем задачи:</p>
                    <ul class="list-disc list-outside space-y-3 ps-5 font-medium">
                        <li>подбор профилей/толщин под конструкцию и технологию обработки;</li>
                        <li>резка по картам/чертежам с контролем допусков;</li>
                        <li>комплектовка, маркировка мест, упаковочные листы;</li>
                        <li>логистика «до ворот», погрузка-разгрузка, согласование тайм-слотов.</li>
                    </ul>
                </div>
                <div class="bg-grayBg p-5 md:p-10 rounded-lg md:rounded-2xl">
                    <h2 class="text-2xl md:text-3xl font-bold mb-5">
                        Как начать сотрудничество
                    </h2>
                    <p class="mb-3">
                        Оставьте заявку — подготовим КП под объёмы, номенклатуру и график поставок. Закрепим персонального менеджера и согласуем SLA.
                    </p>
                    <ul class="list-disc list-outside space-y-3 ps-5 font-medium">
                        <li>спецусловия и фиксация цены для регулярных закупок;</li>
                        <li>личный кабинет: онлайн-заказы и статусы отгрузок;</li>
                        <li>полный пакет документов: НДС, ЭДО, возможна отсрочка.</li>
                    </ul>
                    <button
                        @click.prevent="openForm"
                        class="mt-4 flex justify-center items-center text-white md:hover:text-baseColor border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg text-sm px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase"
                    >
                        Оставить заявку
                    </button>
                </div>
            </div>
        </div>
        <section class="container">
            <FaqComponent
                title="FAQ для производственных цехов"
                schema-id="schema-btwob-workshop-faq-jsonld"
                subtitle="Ключевые условия: номенклатура, резка и допуски, объёмы, доставка и документы."
                :items="faqItems"
            />
        </section>
    </div>
</template>

<style scoped lang="scss">
</style>
